import React, { useEffect, useRef, useState } from "react";
import { Button, NavBar, Grid, Toast, Mask, DatePicker, Divider, List, Image } from "antd-mobile";
import { APPLICATION_SCREEN, ISwitchScreenAction } from "../../App";
import RequestHelper from "../../common/RequestHelper";
import LoadingView from "../../components/LoadingView";
import { Bounce, ToastContainer, toast } from 'react-toastify';
import moment from "moment";
import { sendTelegramMessage } from "../../common/utils";
import { TELEGRAM_GROUP_ID, TELEGRAM_TOKEN_HOROSCOPE } from "../../common/Constants";
import img11 from '../../assets/11.jpg'
import img22 from '../../assets/22.jpg'
import img33 from '../../assets/33.jpg'
import img1 from '../../assets/1.jpg'
import img2 from '../../assets/2.jpg'
import img3 from '../../assets/3.jpg'
import img4 from '../../assets/4.jpg'
import img5 from '../../assets/5.jpg'
import img6 from '../../assets/6.jpg'
import img7 from '../../assets/7.jpg'
import img8 from '../../assets/8.jpg'
import img9 from '../../assets/9.jpg'

type INumberMeaning = {
  [key: string]: {
    title: string;
    features: string[];
    img: any
  };
};

const dataListLifeNumbers: INumberMeaning = {
  "1": {
    title: "Số 1 – Nhà lãnh đạo",
    features: ["Tính cách: Độc lập, quyết đoán, sáng tạo, thích làm người tiên phong."
      , "Điểm mạnh: Khả năng dẫn dắt, có tầm nhìn, dũng cảm.", "Thách thức: Dễ bướng bỉnh, đôi khi quá cứng nhắc, thích kiểm soát."],
      img: img1
  },
  "2": {
    title: "Số 2 – Người hòa giải",
    features: ["Tính cách: Nhạy cảm, dịu dàng, giỏi lắng nghe và hòa giải.", "Điểm mạnh: Thấu hiểu, hợp tác tốt, biết chăm sóc",
      "Thách thức: Dễ phụ thuộc, thiếu quyết đoán, sợ xung đột."
    ],
    img: img2
  },
  "3": {
    title: "Số 3 – Người sáng tạo",
    features: ["Tính cách: Lạc quan, giàu cảm hứng, sáng tạo, giao tiếp tốt.", "Điểm mạnh: Nghệ sĩ, năng lượng tích cực, khả năng diễn đạt tốt."
      ,"Thách thức: Dễ phân tán, thiếu kỷ luật, đôi khi hời hợt."
    ],
    img: img3
  },
  "4": {
    title: "Số 4 – Người xây dựng",
    features: ["Tính cách: Chăm chỉ, thực tế, kỷ luật, đáng tin cậy.", "Điểm mạnh: Kiên trì, có hệ thống, giỏi xây dựng nền tảng vững chắc.",
      "Thách thức: Bảo thủ, cứng nhắc, thiếu linh hoạt."
    ],
    img: img4
  },
  "5": {
    title: "Số 5 – Người thích tự do",
    features: ["Tính cách: Phóng khoáng, thích phiêu lưu, yêu tự do", "Điểm mạnh: Thích khám phá, dễ thích nghi, giàu trải nghiệm.",
      "Thách thức: Dễ bốc đồng, thiếu kiên nhẫn, sợ ràng buộc."
    ],
    img: img5
  },
  "6": {
    title: "Số 6 – Người chăm sóc",
    features: ["Tính cách: Tận tâm, trách nhiệm, yêu thương.","Điểm mạnh: Chu đáo, yêu gia đình, sẵn sàng giúp đỡ người khác.",
      "Thách thức: Dễ lo lắng, can thiệp quá mức, đôi khi hi sinh bản thân quá nhiều."
    ],
    img: img6
  },
  "7": {
    title: "Số 7 – Nhà triết gia",
    features: ["Tính cách: Trí tuệ, thích khám phá chiều sâu, yêu sự yên tĩnh.", "Điểm mạnh: Phân tích tốt, sâu sắc, thông thái.",
      "Thách thức: Khó gần, dễ cô lập, đôi khi hoài nghi quá mức."
    ],
    img: img7
  },
  "8": {
    title: "Số 8 – Người quyền lực",
    features: ["Tính cách: Tham vọng, quyết đoán, giỏi quản lý.","Điểm mạnh: Khả năng lãnh đạo, quản lý tài chính tốt, mạnh mẽ.",
      "Thách thức: Dễ bị vật chất chi phối, thích kiểm soát, đôi khi cứng nhắc."
    ],
    img: img8
  },
  "9": {
    title: "Số 9 – Người nhân đạo",
    features: ["Tính cách: Bao dung, nhân ái, yêu thương cộng đồng.", "Điểm mạnh: Trái tim lớn, giàu lòng vị tha, muốn giúp đỡ mọi người.",
      "Thách thức: Dễ hi sinh bản thân quá mức, đôi khi thiếu thực tế."
    ],
    img: img9
  },
  "11": {
    title: "11 – Nhà trực giác: Trực giác mạnh mẽ, kết nối tâm linh, sáng suốt.",
    features: [],
    img: img11
  } ,
  "22": {
    title: "22 – Nhà kiến tạo: Tham vọng lớn, khả năng biến giấc mơ thành hiện thực.",
    features: [],
    img: img22
  },
  "33": {
    title: "33 – Nhà thầy vĩ đại: Yêu thương vô điều kiện, mang sứ mệnh cao cả.",
    features: [],
    img: img33
  }
}

export default function LifeNumber({ setScreen } : ISwitchScreenAction) {

  interface IListItem {
    id?: string,
    name: string,
    icon: string,
    link: string
  }

  interface IHoroscope {
    summary: string, 
    overall: {name: string, star: number, summary: string}[]
  }

  const [resultNumber, setResultNumber] = useState<undefined | number>();
  const difContainer = useRef()
  const [birthdate, setBirthdate] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [birthdayInput, setBirthdayInput] = useState('')

  const calculateLifePathNumber = (date: string) => {
    const digits = date.replace(/[^0-9]/g, '');
    let sum = digits.split('').reduce((acc, num) => acc + parseInt(num, 10), 0);

    while (sum > 9 && sum !== 11 && sum !== 22 && sum !== 33) {
      sum = sum.toString().split('').reduce((acc, num) => acc + parseInt(num, 10), 0);
    }

    return sum;
  };

  const handleCalculate = () => {
    if (!birthdate) {
      console.log('No birthday');
      return;
    }
    const lifePathNumber = calculateLifePathNumber(birthdate);
    console.log(`Life Number: ${lifePathNumber}`);
    setResultNumber(lifePathNumber)
    setShowResult(true)
    const info = dataListLifeNumbers[`${lifePathNumber}`];
    sendTelegramMessage(TELEGRAM_GROUP_ID, TELEGRAM_TOKEN_HOROSCOPE, `Life Number: ${lifePathNumber} - Birthday: ${birthdayInput} - ${info.title}`)
  };

  const renderInput = () => {
    return <div className="grid-container">
        <div className="flex flex-col items-center gap-4 p-4" style={{marginLeft: 36}}>
      <Button
        className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
        onClick={() => {
          console.log('show date picker')
          setShowDatePicker(true)
        }}
      >
        Chọn ngày tháng năm sinh
      </Button>

      {Boolean(birthdayInput) && <span style={{fontSize: 14, fontWeight: '600', marginLeft: 8, marginRight: 16}}>Ngày sinh: {birthdayInput}</span>}

      {Boolean(birthdayInput) && <Button
        color="success"
        onClick={handleCalculate}
        style={{marginTop: 16}}
      >
        Xem kết quả
      </Button>}
      <DatePicker
        title='Chọn ngày tháng năm sinh'
        visible={showDatePicker}
        cancelText="Huỷ"
        confirmText="Xác nhận"
        defaultValue={new Date(2000, 0, 1)}
        min={new Date(1900, 0, 1)}
        onClose={() => {
          setShowDatePicker(false)
        }}
        max={new Date()}
        onConfirm={val => {
          setBirthdayInput(moment(val).format('DD/MM/yyyy'))
          setBirthdate(moment(val).format('DDMMyyyy'))
        }}
      />
    </div>
  </div>
  }
  const renderResultFinal = (luckyNumber?: number) => {
    if (!luckyNumber) {
      return <div></div>
    }
    const info = dataListLifeNumbers[`${luckyNumber}`];
    return <div style={{display: 'flex', flexDirection: 'column'}}>
      <div style={{display: 'flex',flexDirection: 'column', alignItems: 'center', width: '100%', position: 'relative'}}>
        <Image src={info.img} width={296} style={{borderRadius: 16, position: 'absolute', width: '100%', objectFit: 'contain', opacity: 0.23, height: 296}}/>
        <Image src={info.img} width={256} style={{borderRadius: 16, marginBottom: 28, marginTop: 20}}/>
        </div>
      {info.features.length > 0 && <List header={<span style={{fontSize: 21, color: '#189e4f'}}>{info.title}</span>}>
        {info.features.map((feature, index) => <List.Item key={index}>{feature}</List.Item>)}
      </List>}
      {(luckyNumber === 11 || luckyNumber === 22 || luckyNumber === 33) && <span style={{fontSize: 21, color: '#189e4f', marginTop: 16}}>Đây là 1 trong 3 con số rất đặc biệt (11,22,33)! Bạn rất đặc biệt đấy nhé! <br/><br/>{info.title}</span>}
    </div>
  }

  const renderDetails = () => {
    let title = ''
    title = `Kết quả Thần Số Học`
    const ele = document.getElementById('divContainer')
    let height = '100%'
    if (ele?.clientHeight) {
      height = `${ele.clientHeight - 86}px`
      console.log(height, ele.clientHeight)
    }
    return <div   id="divContainer" ref={difContainer.current} style={{position: 'absolute', left: 0, right: 0, bottom: 0, top: 0}}>
      <NavBar style={{backgroundColor: 'white', whiteSpace: 'nowrap', overflow: 'hidden' }} onBack={()=> {
             setShowResult(false)
             setResultNumber(undefined)
      }} >{title}</NavBar>
      <div  style={{marginTop: 0, height: '100%'}}>
        <div style={{
          display: 'flex', 
          flexDirection: 'column', 
          borderColor: 'rgba(16, 20, 27, 0.08)', 
          borderStyle: 'solid', 
          borderWidth: 1, 
          marginTop: 8,
          marginBottom: 16,
          marginLeft: 16, marginRight: 16,
          paddingLeft: 16, paddingRight: 16,
          backgroundColor: 'white',
          height: 'calc(100% - 86px)',
          borderRadius: 16}}>

          <div style={{overflow: 'scroll', overflowY: 'scroll', height:height, display: 'flex', flexDirection: 'column'}}>
                  <div className="max-w-xl mx-auto p-4">
                <div className="grid gap-4">
                    <div style={{margin: 16}}><span className="text-lg mb-2" style={{fontSize: 14, lineHeight: 1.5}}>Dựa theo ngày tháng năm sinh <span style={{color: '#189e4f'}}>{moment(birthdayInput, 'DD/MM/yyyy').format('DD/MM/yyyy')}</span> thì con số chủ đạo của bạn là: <span style={{fontSize: 16, color: '#189e4f',  marginLeft: 4}}>Số {resultNumber}</span> !</span></div>
                    {renderResultFinal(resultNumber)}

                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  }

  return (
    <div>
      <NavBar style={{}} onBack={()=> {
              // setScreen(APPLICATION_SCREEN.JOIN_GAME_INPUT)
      }} >Thần Số Học của bạn</NavBar>
      <div  style={{marginTop: 8}}>
      <div style={{
        display: 'flex', 
        flexDirection: 'column', 
        borderColor: 'rgba(16, 20, 27, 0.08)', 
        borderStyle: 'solid', 
        borderWidth: 1, 
        paddingBottom: 16,
        borderRadius: 16}}>
          
        {renderInput()}
      </div>
      </div>
        <Mask visible={showResult} onMaskClick={()=> {
          setShowResult(false)
        }}>
          {renderDetails()}
        </Mask>
    </div>
  );
}
